import {Box} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import SettingsIcon from "@material-ui/icons/Settings";
import React, {ReactElement} from "react";
import {useAdminPendingVerifiedDomainsCount} from "hooks/verifiedDomain/useAdminPendingVerifiedDomainsCount";
import DashboardIcon from "view/images/DashboardIcon";
import OrganiserIcon from "view/images/OrganiserIcon";
import {ExhibitorsIcon, SuppliersIcon} from "view/images/navigationIcons";
import {
  ADMIN_COUNTRIES_PATH,
  ADMIN_FEATURES_PATH,
  ADMIN_PRO_FEATURES_PATH,
  APP_PATH,
  EXHIBITORS_PATH,
  ORGANISERS_LIST_PATH,
  SETTINGS_PATH,
  SUPPLIERS_LIST_PATH,
  USERS_PATH,
} from "view/routes";
import BuildIcon from "@material-ui/icons/Build";
import LockIcon from "@material-ui/icons/Lock";
import GroupIcon from "@material-ui/icons/Group";
import PublicIcon from "@material-ui/icons/Public";
import NavItem, {NavList} from "./Nav";

const AdminNavigation = (): ReactElement => {
  const pendingDomainsCount = useAdminPendingVerifiedDomainsCount();

  return (
    <Box>
      <NavList>
        <NavItem to={APP_PATH} icon={DashboardIcon} name="Dashboard" />
        <NavItem
          to={ORGANISERS_LIST_PATH}
          icon={OrganiserIcon}
          name="Organisers"
        />
        <NavItem to={USERS_PATH} icon={GroupIcon} name="Admins" />
        <NavItem
          to={ADMIN_PRO_FEATURES_PATH}
          icon={LockIcon}
          name="PRO Features"
        />
        <NavItem to={EXHIBITORS_PATH} icon={ExhibitorsIcon} name="Exhibitors" />
        <NavItem to={ADMIN_COUNTRIES_PATH} icon={PublicIcon} name="Countries" />
        <NavItem
          to={SUPPLIERS_LIST_PATH}
          icon={SuppliersIcon}
          name="Suppliers"
        />
        <NavItem to={ADMIN_FEATURES_PATH} icon={BuildIcon} name="Features" />
      </NavList>
      <Divider />
      <NavList>
        <NavItem
          to={SETTINGS_PATH}
          icon={SettingsIcon}
          name="Settings"
          badgeCount={pendingDomainsCount}
        />
      </NavList>
    </Box>
  );
};

export default AdminNavigation;
